import * as React from "react";
const SvgSendArrowIcon = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 100 100", ...props }, /* @__PURE__ */ React.createElement("polygon", { points: "98 47.56 51.04 2 3.24 47.52 11.81 56.52 44.72 25.17 44.39 97.36 56.81 97.42 57.15 25.23 89.35 56.48 98 47.56" }));
export default SvgSendArrowIcon;
